"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEPARTMENT_RESPONSIBILITY_DEFINITIONS = void 0;
var types_1 = require("./types");
var types_2 = require("../customers/types");
exports.DEPARTMENT_RESPONSIBILITY_DEFINITIONS = [
    {
        responsibility: types_1.DepartmentResponsibilities.AGRICULTURE,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'חקלאות' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.ANIMAL_CONTROL,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'פיקוח על בעלי חיים' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.PROPERTY_ASSESSMENT,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'שמאות רכוש' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.AVIATION,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'תְעוּפָה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.COUNTY_COMMISSION,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'ועדה מחוזית' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.CLERK_RECORDER,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { en: 'Clerk & recorder services', he: 'מזכירות ושירותי פרוטוקול' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.COMMUNITY_DEVELOPMENT,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'פיתוח קהילתי' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.COURT_SYSTEM,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'מערכת בתי המשפט' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.PUBLIC_DEFENSE,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'סנגוריה ציבורית' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.PROBATION,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'שירות מבחן' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.SUSTAINABILITY,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'קיימות' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.TAX_COLLECTIONS,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { en: 'Tax & Collections', he: 'מיסוי וגבייה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.VETERANS_AFFAIRS,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'פורשי צבא' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.ELECTIONS,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'בחירות' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.JAILS,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'מתקני כליאה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.FISCAL_AFFAIRS,
        availableForCustomerTypes: [types_2.CustomerTypes.COUNTY],
        displayName: { he: 'נושאי תקציב' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.BUILDING_AND_ZONING,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY],
        displayName: { en: 'Building & Zoning', he: 'תכנון ובניה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.CITY_CLERK,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY],
        displayName: { he: 'מזכירות העירייה או הרשות' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.BUDGET,
        availableForCustomerTypes: [
            types_2.CustomerTypes.CITY,
            types_2.CustomerTypes.COUNTY,
            types_2.CustomerTypes.STATE_AGENCY,
        ],
        displayName: { he: 'תקציבים' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.COMMUNICATIONS,
        availableForCustomerTypes: [
            types_2.CustomerTypes.CITY,
            types_2.CustomerTypes.COUNTY,
            types_2.CustomerTypes.STATE_AGENCY,
            types_2.CustomerTypes.LAW_ENFORCEMENT_AGENCY,
        ],
        displayName: { he: 'תקשורת' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.COMMUNITY_RELATIONS,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY],
        displayName: { he: 'קשרי קהילה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.CULTURAL_AFFAIRS,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'תרבות' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.ECONOMIC_DEVELOPMENT,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'פיתוח כלכלי' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.EDUCATION,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'חינוך' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.EMERGENCY_MANAGEMENT,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'ניהול בשעת חירום' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.ENGINEERING,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'הנדסה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.ENVIRONMENTAL_SERVICES,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY],
        displayName: { he: 'שירותים סביבתיים' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.FINANCIAL_ADMIN_SERVICES,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.STATE_AGENCY],
        displayName: { en: 'Financial & admin services', he: 'שירותים פיננסיים וניהוליים' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.FIRE_RESCUE,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { en: 'Fire/Rescue', he: 'כבאות והצלה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.HOUSING,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'דיור' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.HUMAN_RESOURCES,
        availableForCustomerTypes: [
            types_2.CustomerTypes.CITY,
            types_2.CustomerTypes.COUNTY,
            types_2.CustomerTypes.STATE_AGENCY,
        ],
        displayName: { he: 'משאבי אנוש' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.IT_INFORMATION_SERVICES,
        availableForCustomerTypes: [
            types_2.CustomerTypes.CITY,
            types_2.CustomerTypes.COUNTY,
            types_2.CustomerTypes.STATE_AGENCY,
        ],
        displayName: { en: 'IT & information services', he: 'שירותי IT ומידע' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.INNOVATION,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY],
        displayName: { he: 'חדשנות' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.LEGISLATIVE,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY],
        displayName: { he: 'חקיקה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.PARKS_RECREATION,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { en: 'Parks & recreation', he: 'פארקים ונופש' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.PLANNING_AND_DEVELOPMENT,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { en: 'Planning & development', he: 'תכנון ופיתוח' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.PUBLIC_SAFETY,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'בטיחות הציבור' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.PUBLIC_HEALTH,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'בריאות הציבור' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.PUBLIC_WORKS,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'שיפור פני העיר' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.WASTE_MANAGEMENT,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'אשפה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.SOCIAL_SERVICES,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'שירותים סוציאליים' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.TOURISM,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY],
        displayName: { he: 'תיירות' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.TRANSPORTATION,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'תחבורה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.TRANSIT_AUTHORITY,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY],
        displayName: { he: 'תעבורה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.INFRASTRUCTURE,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'תשתיות' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.WATER_WASTEWATER_UTILITIES,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { en: 'Water & wastewater utilities', he: 'שירותי מים ושפכים' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.DEI,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY],
        displayName: { en: 'DEI (Diversity, equity & inclusion)', he: 'שוויון ומגוון' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.REPORTS_AUDITS,
        availableForCustomerTypes: [
            types_2.CustomerTypes.CITY,
            types_2.CustomerTypes.COUNTY,
            types_2.CustomerTypes.STATE_AGENCY,
        ],
        displayName: { en: 'Reports & audits', he: 'דוחות וביקורות' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.CODE_ENFORCEMENT,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'אכיפה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.LIBRARIES,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY, types_2.CustomerTypes.COUNTY],
        displayName: { he: 'ספריות' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.LICENSING_PERMITTING,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY],
        displayName: { en: 'Licensing & permitting', he: 'רישוי והיתרים' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.ZOO,
        availableForCustomerTypes: [types_2.CustomerTypes.CITY],
        displayName: { he: 'גני חיות' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.OTHER,
        availableForCustomerTypes: [
            types_2.CustomerTypes.CITY,
            types_2.CustomerTypes.COUNTY,
            types_2.CustomerTypes.LAW_ENFORCEMENT_AGENCY,
            types_2.CustomerTypes.STATE_AGENCY,
        ],
        displayName: { he: 'אחר' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.ADMINISTRATION,
        availableForCustomerTypes: [types_2.CustomerTypes.LAW_ENFORCEMENT_AGENCY, types_2.CustomerTypes.STATE_AGENCY],
        displayName: { en: 'Administration/Executive management', he: 'אדמיניסטרציה/ניהול ביצוע' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.PATROL_OPERATIONS,
        availableForCustomerTypes: [types_2.CustomerTypes.LAW_ENFORCEMENT_AGENCY],
        displayName: { he: 'פעולות סיור' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.INVESTIGATIVE_SERVICES,
        availableForCustomerTypes: [types_2.CustomerTypes.LAW_ENFORCEMENT_AGENCY],
        displayName: { he: 'שירותי חקירה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.SUPPORT_SERVICES,
        availableForCustomerTypes: [types_2.CustomerTypes.LAW_ENFORCEMENT_AGENCY],
        displayName: { he: 'שירותי תמיכה' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.COURT_SERVICES,
        availableForCustomerTypes: [types_2.CustomerTypes.LAW_ENFORCEMENT_AGENCY],
        displayName: { he: 'שירותי בית משפט' },
    },
    {
        responsibility: types_1.DepartmentResponsibilities.CORRECTIONS,
        availableForCustomerTypes: [types_2.CustomerTypes.LAW_ENFORCEMENT_AGENCY],
        displayName: { he: 'תיקוני חקיקה' },
    },
];
